module.exports = __webpack_public_path__ + "static/media/VV 23.66df02fd.mp3";